module.exports = __webpack_public_path__ + "605ae7db1f0bc22ceacfacfd3b0c9e43.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/quotes-2.png
// module id = 1052
// module chunks = 0